import React from "react";
import {BrowserRouter as Router, Routes,Route,} from "react-router-dom";
import Greek from "./components/Greek_Menu"
import English from "./components/English_Menu"
import "./styles.css";
export default function App() {
  return (
    <Router>
        <Routes>
          <Route path="" element={<Greek />} />
          <Route path="/en" element={<English />} />
        </Routes>
    </Router>

  );
}
